module.exports = __webpack_public_path__ + "img/icon-diy-integrations.f1e32f3f.svg";